import { Col, Layout, Row, Space } from 'antd';
import * as React from 'react';
import { ReactNode, useCallback, useState } from 'react';
import styled from 'styled-components';
import { LogoIcon } from 'common/components/Logo';
import { useQueryCache } from 'react-query';
import { SiderToggle } from 'common/components/SidenavToggle';
import { ProfileButton } from 'common/organisms/ProfileButton';
import { LanguageControl } from 'common/organisms/LanguageControl';
import { Footer } from 'common/components/Footer';
import { useRole } from 'common/hooks/useRole';
import { userRoleLabelMap } from 'models/token';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const { Header, Sider, Content } = Layout;

const StyledSiderToggle = styled(SiderToggle)`
  margin-left: 1.5rem;
`;

const LogoContainer = styled(Space)`
  height: 4rem;
  padding: 1rem 1rem 1rem 1.7rem;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  user-select: none;
`;

const StyledSider = styled(Sider)`
  box-shadow: 0 0 6px -1px rgba(0, 0, 0, 0.25);
`;

const RoleWrapper = styled.span`
  margin: 0 1rem;
`;

export interface LayoutTemplateProps {
  menu: ReactNode;
  children: ReactNode;
  currentRoute: string;
  loading: boolean;
  logout: () => void;
}

const LayoutTemplate: React.FC<LayoutTemplateProps> = ({
  children,
  logout,
  menu,
}) => {
  const queryCache = useQueryCache();
  const handleLogout = useCallback(() => {
    queryCache.clear();
    logout();
  }, [queryCache, logout]);
  const [collapsed, setCollapsed] = useState(false);
  const userRole = useRole();
  const intlMessage = useFormatMessage();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <StyledSider
        theme="light"
        breakpoint="lg"
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <LogoContainer>
          <LogoIcon /> {!collapsed && <span>Higo</span>}
        </LogoContainer>
        {menu}
      </StyledSider>
      <Layout>
        <Header style={{ background: '#fff', padding: 0 }}>
          <Row justify="space-between">
            <Col>
              <StyledSiderToggle
                isCollapsed={collapsed}
                onClick={() => setCollapsed((v) => !v)}
              />
            </Col>

            <Col>
              <RoleWrapper>
                {userRole.role &&
                  intlMessage({
                    id: userRoleLabelMap.get(userRole.role) ?? userRole.role,
                  })}
              </RoleWrapper>
              <LanguageControl />
              <ProfileButton onLogout={handleLogout} />
            </Col>
          </Row>
        </Header>
        <Content>{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

// eslint-disable-next-line import/no-default-export
export default LayoutTemplate;
